import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';

export type RouteErrorKind =
  | 'forbidden'
  | 'missing'
  | 'network'
  | 'rate-limited'
  | 'server'
  | 'session'
  | 'timeout'
  | 'unauthorized'
  | 'unknown';

export const ROUTE_ERROR_MESSAGES: Record<RouteErrorKind, MessageDescriptor> = {
  forbidden: msg`You do not have permission to load this page.`,
  missing: msg`The requested information is no longer available.`,
  network: msg`Could not connect to the service. Check your connection and try again.`,
  'rate-limited': msg`Too many requests were sent. Wait a moment and try again.`,
  server: msg`The service is temporarily unavailable. Please try again shortly.`,
  session: msg`Your session could not be verified. Check your connection and try again.`,
  timeout: msg`The request timed out. Please try again.`,
  unauthorized: msg`Your session has expired. Please sign in again.`,
  unknown: msg`This page could not be loaded. Please try again.`,
};

export const HTTP_ROUTE_ERROR_KIND: Record<number, RouteErrorKind> = {
  401: 'unauthorized',
  403: 'forbidden',
  404: 'missing',
  408: 'timeout',
  429: 'rate-limited',
};

export const AUTH_ROUTE_ERROR_KIND = {
  'missing-session': 'unauthorized',
  'token-failed': 'session',
} as const satisfies Record<string, RouteErrorKind>;
